/**
 * Single source of truth (frontend side) for the literal strings of every
 * onboarding option, calibrated for Verificamex Firma Digital.
 *
 * These strings MUST match, character for character, the backend catalog at:
 *   api-verificamex-firma/src/main/kotlin/com/handersolutions/digitafirma/
 *     application/usecases/onboarding/scoring/OnboardingOptionsCatalog.kt
 *
 * One accent / trailing space / comma of difference = the lead scores 0 in
 * that dimension.
 *
 * Order convention: ascending by score. KO / lowest-value options on top,
 * highest-value at the bottom — decision from product (engagement test).
 */

// 0 (+3 KO) → 10 (+1 KO) → 20 → 50 → 70 → 90 → 100
export const COMPANY_INDUSTRY = [
  'Solo un trámite personal',
  'Soy Freelance',
  'Otro sector empresarial',
  'Inmobiliaria / Construcción',
  'Recursos Humanos / Reclutamiento',
  'Legal / Notarías',
  'Fintech / Financiero',
];

// 30 (×4) → 70 → 220 (flat)
export const SERVICES = [
  'Firma Electrónica Simple (video firma)',
  'Firma Electrónica Simple + Validación INE/CURP/Prueba de vida',
  'Firma Electrónica Avanzada (e.firma SAT / FIREL PJF)',
  // WHY: el string maestro en valores-firma-ask.md trae trailing space deliberado.
  'Constancia NOM-151 + Sellado de tiempo ',
  'Implementar API de Firma Digital',
  'Todas las anteriores',
];

// 0 → 0 → 70 → 100
export const IMPLEMENTATION_TIMELINE = [
  'Solo presupuesto',
  'Aun no hay fechas',
  '2 a 5 meses',
  'Inmediato',
];

// 0 (+2 KO) → 60 → 80 → 100
export const COMPANY_SIZE = [
  'No tengo solo yo / Particular',
  '1 - 50',
  '51 - 200',
  'Más de 200 (Corporativo)',
];

// 0 (+3 KO) → 50 → 80 → 120
export const MONTHLY_VOLUME = [
  'Uso único (solo 1)',
  '50 a 100 Firmas',
  '101 a 1,000 Firmas',
  'Más de 1,000 Firmas',
];

// 10 → 50 → 100 → 150
export const PRIMARY_GOAL = [
  'Solo quiero ver cómo se ve el panel',
  'Firmar un documento de prueba para ver cómo funciona el flujo',
  'Invitar a mi equipo legal/operativo a evaluar la plataforma',
  'Empezar a firmar contratos reales desde el panel esta semana',
];

// 50 → 100 (×3, ordered by thematic priority: compliance → legal → growth)
export const SUCCESS_INDICATOR = [
  'Eliminar papeleo, mensajería y firmas presenciales',
  'Pasar auditorías y cumplir con NOM-151 / regulación',
  'Blindar la validez legal de cada contrato firmado',
  'Acelerar el cierre de contratos con clientes y proveedores',
];

// No scoring impact — left in original order (intuitive groups: paid ads →
// social → organic → other).
export const SOURCE_OPTIONS = [
  'Google',
  'Bing',
  'Anuncio en Facebook',
  'Anuncio en Instagram',
  'Recomendación de un amigo',
  'Tiktok',
  'Podcast',
  'Leí un blog',
  'YouTube',
  'Un asesor',
  'Otro',
];

export const CONTACT_AGENT_YES = 'si';
export const CONTACT_AGENT_NO = 'no';

export const PREFERRED_CONTACT_METHOD = [
  { value: 'correo',   label: 'Correo' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'llamada',  label: 'Llamada' },
];
